import { h } from 'vue';
import { RouterLink } from 'vue-router';
import _get from 'lodash/get';
import type { BuiTblColumn } from '@/components/bui/organisms/Tbl/types';
import TblRowActions from '@/components/bui/molecules/TblRowActions/TblRowActions.vue';
import TimeFormatDateOnly from '@/components/ListingPages/ItemsLister/ItemsList/FieldsRenderers/TimeFormatDateOnly.vue';
import Size from '@/components/ListingPages/ItemsLister/ItemsList/FieldsRenderers/Size.vue';
import UsedBy from '@/components/ListingPages/ItemsLister/ItemsList/FieldsRenderers/UsedBy.vue';

const playlistsColumns: BuiTblColumn[] = [
  {
    key: 'name',
    kind: 'name',
    label: 'Name',
    grow: true,
    minWidth: 180,
    selectable: true,
    sortable: true,
    sortKey: 'name',
    render: ({ item }) =>
      h('div', { class: 'bui-cell-name' }, [
        h(
          RouterLink,
          { to: `/playlists/edit/${item.id}`, class: 'title-link', 'data-testid': 'list-row-title', onClick: (e: MouseEvent) => e.stopPropagation() },
          () => item.name,
        ),
        h('div', { class: 'bui-cell-sub' }, item.assetType ? `${item.assetType[0].toUpperCase()}${item.assetType.substring(1)}` : ''),
      ]),
  },
  {
    key: 'modified',
    kind: 'text',
    label: 'Modified',
    headerTestId: 'playlist-modified-header',
    grow: true,
    minWidth: 110,
    sortable: true,
    sortKey: 'dateLastModified',
    render: ({ item }) => h(TimeFormatDateOnly, { epochTime: item.dateLastModified }),
  },
  {
    key: 'created',
    kind: 'text',
    label: 'Created',
    grow: true,
    minWidth: 110,
    sortable: true,
    sortKey: 'dateCreated',
    render: ({ item }) => h(TimeFormatDateOnly, { epochTime: item.dateCreated }),
  },
  {
    key: 'createdBy',
    kind: 'text',
    label: 'Created by',
    grow: true,
    minWidth: 120,
    render: ({ item }) => _get(item, 'createdBy.group.name', 'None'),
  },
  {
    key: 'size',
    kind: 'text',
    label: 'Size',
    width: 100,
    sortable: true,
    sortKey: 'size',
    render: ({ item }) => h(Size, { size: item.size }),
  },
  {
    key: 'usedBy',
    kind: 'usedBy',
    label: 'Used by',
    width: 80,
    render: ({ item }) => h(UsedBy, { items: item.campaigns, label: 'Campaigns' }),
  },
  {
    key: 'actions',
    kind: 'actions',
    label: 'Actions',
    width: 100,
    render: ({ item }) => h(TblRowActions, { item }),
  },
];

export default playlistsColumns;
